mutation DeleteMerchApp($appKey: String!) {
  result: StreamToolsDeleteMerchApp(appKey: $appKey) {
    id
    deleted
  }
}
